import React, { useState } from 'react';
import { FEATURE_REGISTRY } from '../../features/featureRegistry';
import { isFeatureBeta } from '../../utils/featureStatus';
import './BetaNotice.css';

// Einmaliger, wegklickbarer Hinweis beim Öffnen eines Beta-Features
// (IdeenManager „Wichita", v3.129.0). Erfüllt „der Nutzer muss wissen, dass es
// noch nicht vollständig getestet ist" — ohne die Nutzung zu blockieren.
// Die Zustimmung/Kenntnisnahme wird pro Feature lokal gemerkt (localStorage),
// bewusst ohne Backend: es ist eine reine Anzeige-Entscheidung.

function dismissKey(featureId) {
  return `beta_notice_dismissed_${featureId}`;
}

export default function BetaNotice({ featureId }) {
  const feature = FEATURE_REGISTRY.find((f) => f.id === featureId);
  const beta    = isFeatureBeta(feature);

  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(dismissKey(featureId)) === '1'; }
    catch { return false; }
  });

  if (!beta || dismissed) return null;

  function handleDismiss() {
    try { localStorage.setItem(dismissKey(featureId), '1'); } catch { /* ignore */ }
    setDismissed(true);
  }

  return (
    <div className="beta-notice" role="status">
      <span className="beta-notice__icon">🧪</span>
      <div className="beta-notice__body">
        <strong>Beta-Funktion</strong>
        <span> — {feature?.label ? `„${feature.label}" ` : ''}funktioniert bereits, ist aber noch nicht vollständig getestet. Wir entwickeln sie aktiv weiter; einzelne Ergebnisse können noch fehlerhaft sein.</span>
      </div>
      <button className="beta-notice__close" onClick={handleDismiss} aria-label="Hinweis schließen">Verstanden</button>
    </div>
  );
}
